import { useSafeAreaInsets } from "react-native-safe-area-context";

export const TAB_BAR_PILL_HEIGHT = 64;
export const TAB_BAR_SIDE_MARGIN = 16;
export const TAB_BAR_INDICATOR_SIZE = 48;
export const TAB_BAR_MIN_BOTTOM_GAP = 16;
export const TAB_BAR_CONTENT_GAP = 12;

/** Bottom padding a scrollable tab screen must reserve so content clears the floating bar. */
export function useTabBarHeight() {
  const insets = useSafeAreaInsets();
  const bottomOffset = Math.max(insets.bottom, TAB_BAR_MIN_BOTTOM_GAP);
  return TAB_BAR_PILL_HEIGHT + bottomOffset + TAB_BAR_CONTENT_GAP;
}
